import React, { useState, useReducer, useEffect } from "react"
import {
  Box,
  Button
} from "@mui/material"


const PrepareForMap = ({ rowData, mainProps, setErrorMessage }) => {



  return (
    <Box>
      <Button
        variant="outlined"
        size="small"
        onClick={async () => {
            const { onPrepareForMapByAdmin } = mainProps
            if(window.confirm("ایجاد فایل ایزومتریک-پلان-تایید")){
                await onPrepareForMapByAdmin(rowData.id)
            }
           
        }}
      >
      آماده سازی
      </Button>
    </Box>
  )
}

export default PrepareForMap
